module.exports = __webpack_public_path__ + "static/img/img4-map.91853b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/awards/img4-map.png
// module id = EmFn
// module chunks = 1